import Echo from 'laravel-echo';

window._ = require('lodash');

/** 
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Pusher = require('pusher-js');

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: process.env.MIX_PUSHER_APP_KEY,
	cluster: process.env.MIX_PUSHER_APP_CLUSTER,
	forceTLS: true,
	encrypted: true
});

// Pusher.logToConsole = true;
window.PusherInstance = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
	cluster: process.env.MIX_PUSHER_APP_CLUSTER
});


// jquery
window.$ = window.jQuery = require('jquery');

// jquery plugins
require('jquery-toast-plugin')
require('jquery-validation')
require('jquery-ui/ui/widgets/datepicker')

// sweetalert2
import Swal from '@/react/components/Swal'
window.Swal = Swal
// anime 
import anime from 'animejs/lib/anime.es.js';
window.anime = anime;

// gsap
import { gsap } from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin)

// tippy {this is buggy at the moment}
// import tippy, { createSingleton } from 'tippy.js';
// window.tippy = tippy;
// window.tippy.createSingleton = createSingleton;

// react
import React from 'react';
import ReactDOM from 'react-dom/client';

window.React = React
window.ReactDOM = ReactDOM
const reactRoots = new WeakMap();

window.renderReactComponent = (root, component, props) => {
	let rootElement;
	if (typeof root === 'string') {
		rootElement = document.querySelector(root);
	} else {
		rootElement = root;
	}
	if (!rootElement) {
		console.warn(`Root element with selector ${root} not found`);
		return;
	}

	let reactRoot = reactRoots.get(rootElement);

	if (!reactRoot) {
		// Create root once
		reactRoot = ReactDOM.createRoot(rootElement);
		reactRoots.set(rootElement, reactRoot);
	}

	// Always render into the existing root
	reactRoot.render(React.createElement(component, props));
};

window.ReactComponents = {}
window.ReactPages = {}

function loadModules(moduleContext, modulePath, windowObjectToStoreTo) {
	const componentName = modulePath.replace(/^.*[\\\/]/, '').split('.')[0];
	const componentDirectory = modulePath.replace('/' + componentName + '.jsx', '').replace('/' + componentName + '.tsx', '').replace('./', '').replace('.', '');
	const componentModule = moduleContext(modulePath);
	const arr = componentDirectory.split('/'); // this yields [folder1, folder2], now we need to do window.ReactComponents[folder1][folder2]

	if (componentDirectory === '') {
		windowObjectToStoreTo[componentName] = componentModule.default || {};

		for (const key in componentModule) {
			if (key === 'default') continue
			windowObjectToStoreTo[componentName][key] = componentModule[key];
		}

	} else {
		let obj = windowObjectToStoreTo;
		arr.forEach(key => {
			if (!obj[key]) {
				obj[key] = {};
			}
			obj = obj[key];
		});

		obj[componentName] = componentModule.default || {};

		for (const key in componentModule) {
			if (key === 'default') continue
			obj[componentName][key] = componentModule[key];
		}
	}
}

// React Components
const componentContext = require.context('./react/components/', true, /^(?!_)(.*\/)?[^\/]*\.(jsx|tsx)$/);
componentContext.keys().forEach((componentPath) => {
	// Exclude components with underscores and the pages folder
	if (!componentPath.includes('/_') && !componentPath.startsWith('_') && !componentPath.includes('/pages/')) {
		loadModules(componentContext, componentPath, window.ReactComponents);
	}
});

// React pages
const pageContext = require.context('./react/pages/', true, /^(?!_)(.*\/)?[^\/]*\.(jsx|tsx)$/);
pageContext.keys().forEach((pagePath) => {
	// Exclude pages with underscores
	if (!pagePath.includes('/_') && !pagePath.startsWith('_')) {
		loadModules(pageContext, pagePath, window.ReactPages);
	}
})

// react specifc libraries
// react-hot-toast
import ToasterWrapper from '@/react/components/ToasterWrapper'
window.toast = ToasterWrapper.toast

if (document.getElementById('react-hot-toast'))
	ReactDOM.createRoot(document.getElementById('react-hot-toast')).render(<ToasterWrapper.Toaster />)
else
	console.warn('react-hot-toast dom element not found. Please add <div id="react-hot-toast"></div> to your html file to enable toast() functionality.')

// CryptoJS & moment (for header hash)
//import SHA256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import moment from 'moment';

/**
 * String Encription using crypto-js. It's using in Dashboard (Laravel) to encript and decrypt in a same way
 *
 * @param string value
 * @param string key | 01234567890123456789012345678901 (32 bytes)
 * @param string iv | 1234567890123412 (16 bytes)
 * @return string
 */
const strEncrypt = function (value, key = "01234567890123456789012345678901", iv = "1234567890123412") {
	let DataKey = CryptoJS.enc.Utf8.parse(key);
	let DataVector = CryptoJS.enc.Utf8.parse(iv);
	let encrypted = CryptoJS.AES.encrypt(value, DataKey, { iv: DataVector, }).toString();

	return encrypted;
};

// HEADER_OBJ
window.makeHash = () => {
	return strEncrypt(BACKENDAPI_KEY + moment.utc().format('Y-MM-DD HH'));
}
// deprecated
window._makeHash = () => {
	// UTC time
	let b = moment.utc().format('MMMM Do YYYY, h');
	let hash = SHA256(`f1nd1ngn3m0${b}`).toString()
	return hash;
}

window.HEADER_OBJ = {
	"x-user": (() => {
		if (typeof ENC_USER !== 'undefined')
			return ENC_USER
	})(),
	"Content-Type": "application/json",
	"X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content'),
	get token() {
		return window.makeHash()
	}
}

// SortableJS
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// ExcelJS
import ExcelJS from 'exceljs';
window.ExcelJS = ExcelJS;

// Highlight.js
import hljs from 'highlight.js';
import python from 'highlight.js/lib/languages/python';

hljs.registerLanguage('python', python);
window.hljs = hljs;

// axios middleware
import axios from 'axios'
// Create an Axios instance
const apiClient = axios.create();
// Add a request interceptor to inject headers
apiClient.interceptors.request.use(config => {
	config.headers = {
		...(config.headers || {}),
		...(window.HEADER_OBJ || {})
	};
	return config;
});

window.ApiClient = apiClient

// custom components
window.__ = {}
function extendWindow(object) {
	window.__ = {
		...window.__,
		...object
	}
}

export function addAbsoluteReactComponent(component) {
	window.ReactComponentsAbsolute = {
		...(window.ReactComponentsAbsolute || {}),
		...component
	}
}

function initElements() {
	extendWindow({
		disableSelect: (event, selector) => {
			const wrapper = document.querySelector(selector).closest('.multi-checkbox-select-wrapper')
			const select = $(wrapper.querySelector(selector))
			if (event.target.checked) {
				select.clear()
				wrapper.classList.add('disabled')
			} else {
				wrapper.classList.remove('disabled')
			}
		}
	})

	// on enter press select closest button
	// delegate({
	// 	selector: 'input',
	// 	event: 'keydown',
	// 	handler: (input, event) => {
	// 		if (event.key === 'Enter') {
	// 			// recursivley find the closest button
	// 			let button
	// 			let parent = input.parentElement
	// 			while (parent) {
	// 				if (parent.querySelector('button')) {
	// 					button = parent.querySelector('button')
	// 					break
	// 				}
	// 				parent = parent.parentElement
	// 			}

	// 			if (button) {
	// 				button.click()
	// 			}
	// 		}
	// 	}
	// })

	document.querySelectorAll('[data-tabs]').forEach(wrapper => {
		TabLayout.init(wrapper);
	})

	document.querySelectorAll('[data-breadcrumb]').forEach(wrapper => {
		BreadCrumb.init(wrapper);
	})

	document.querySelectorAll('.control-center .form_reset').forEach(resetButton => {
		// get the form
		const form = resetButton.closest('form')

		resetButton.addEventListener('click', function () {
			// clear the form
			form.reset()

			// clear the inputs
			form.querySelectorAll('input').forEach(input => input.value = '')
		})
	})

	Flow.initFlow()

	//tippy
	const initTippy = (element) => {
		if (element.classList.contains('tippy-initialized')) return
		const options = element.dataset.tippyOptions ? JSON.parse(element.dataset.tippyOptions) : {}
		tippy(element, {
			theme: 'fk',
			appendTo: document.body,
			animation: 'shift-away',
			allowHTML: true,
			...options
		})
		element.classList.add('tippy-initialized')
	}
	
	const handleTippyInitialization = (node) => {
		if (node.dataset?.tippyOptions) {
			initTippy(node);
			return;
		}
		const elements = node.querySelectorAll('[data-tippy-options]');
		elements.forEach(element => {
			initTippy(element);
		});
	};

	// observer to see if any element has data-tippy-content, if so, init tippy on those elements
	const targetNode = document.body;

	// Call this function on page load to handle existing elements
	handleTippyInitialization(targetNode);

	// Options for the observer (which mutations to observe)
	const config = { childList: true, subtree: true, attributes: true };

	// Callback function to execute when mutations are observed
	const callback = (mutationsList) => {
		for (const mutation of mutationsList) {
			// Check if new nodes are added
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach(node => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						handleTippyInitialization(node)
					}
				});
			}
		}
	};

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback);

	// Start observing the target node for configured mutations
	observer.observe(targetNode, config);

	// for label-btn in table-actions
	const options = {
		placement: 'top',
		theme: 'fk',
		animation: 'shift-away',
	}

	document.querySelectorAll('.label-btn').forEach(labelBtn => {
		if (labelBtn.dataset.tippyContent === undefined) return
		labelBtn.dataset.tippyOptions = JSON.stringify(options)
		initTippy(labelBtn)
	})

	window.Select.init()

	// for react components
	function mountReactNode(node) {
		if (!node) return;

		// If the node itself has data-react-component
		if (node.dataset?.reactComponent) {
			const props = node.dataset.reactProps ? JSON.parse(node.dataset.reactProps) : {};

			if (node.dataset.reactComponent.startsWith('[') && node.dataset.reactComponent.endsWith(']')) {
				const component = window.ReactComponentsAbsolute[node.dataset.reactComponent.replace(/\[|\]/g, '')] ?? null;
				if (!component) return;
				window.renderReactComponent(node, component, props);
				return;
			}

			const keys = node.dataset.reactComponent.split(".");
			let component = window.ReactComponents;
			for (const key of keys) {
				component = component?.[key];
				if (!component) return;
			}
			window.renderReactComponent(node, component, props);
			return;
		}

		// Also check descendants
		node.querySelectorAll?.('[data-react-component]').forEach(mountReactNode);
	}

	// Observe future nodes
	const reactObserver = new MutationObserver(mutationsList =>
		mutationsList.forEach(mutation => mutation.addedNodes.forEach(mountReactNode))
	);

	reactObserver.observe(targetNode, { childList: true, subtree: true });
	document.querySelectorAll('[data-react-component]').forEach(mountReactNode);
}

// imports
import RetentionSchedule from '@/libraries/retention-schedule';
import MultiCheckboxSelect from '@/libraries/multi-checkbox-select';
import MultiLayerDropdown from '@/libraries/multi-layer-dropdown';
import DataTable, { Api, Config } from 'datatables.net-dt';
import FkDataTable, { PARSE_FORM_IN_ROVIEWER_FASHION } from '@/libraries/fk-data-table';
import QCDataTable from '@/libraries/fk-data-table/qc-table';
import ListSelection from '@/libraries/list-select';
import ContextMenu from '@/libraries/context-menu';
import Flow from '@/libraries/flow';
import '@/libraries/info-slider';
import FkTextEditor from '@/libraries/text-editor';

import Select from '@/libraries/select';
import Threads from './libraries/threads';

import Theme from '@/components/theme';
import TabLayout from '@/components/tabLayout';
import BreadCrumb from '@/components/breadcrumb';
import Modal from '@/components/modal';
import ElementBox from '@/components/elementBox';
import delegate from '@/components/delegate';
import ButtonFunctions from '@/components/buttonFunctions';
import ThemeChanger from '@/components/themeChanger';

// libraries
window.DataTable = DataTable

// FkDataTable
window.FkDataTable = FkDataTable

// QCDataTable
window.QCDataTable = QCDataTable

// retention schedule
window.RetentionSchedule = RetentionSchedule

// multi checkbox select
window.MultiCheckboxSelect = MultiCheckboxSelect

// multi layer dropdown
window.MultiLayerDropdown = MultiLayerDropdown

// list selection
window.ListSelection = ListSelection

// context menu
window.ContextMenu = ContextMenu

// text editor
window.FkTextEditor = FkTextEditor

// flow
window.Flow = Flow
window.initFlow = Flow.initFlow

// select
window.Select = Select

// threads
window.Threads = Threads

// components
// sidebar
extendWindow({
	toggleSidebar: (button) => {
		const sidebar = document.querySelector('#sidebar')
		sidebar.classList.toggle('collapsed')

		let totalWidth = 0
		sidebar.childNodes.forEach(element => {
			if (element.nodeType === Node.ELEMENT_NODE) {
				totalWidth += element.offsetWidth
			}
		})
		totalWidth += 'px'
		if (sidebar.classList.contains('collapsed')) {
			button.querySelector('span').innerHTML = 'left_panel_open'

			sidebar.classList.remove('shadowed')

			// sidebar
			anime({
				targets: '#sidebar',
				width: 0,
				easing: 'easeInOutCubic',
				duration: 400,
			})

		} else {
			button.querySelector('span').innerHTML = 'left_panel_close'

			sidebar.classList.add('shadowed')
			anime({
				targets: '#sidebar',
				width: totalWidth,
				easing: 'easeInOutCubic',
				duration: 400,
				translateX: 0,
			})
		}
	}
})

// functions
extendWindow({
	PARSE_FORM_IN_ROVIEWER_FASHION
})

window.addEventListener('resize', function () {
	try {
		if (window.innerWidth < Theme.screens.xl.replace('px', '') && document.querySelector('#sidebar').classList.contains('collapsed') === false) {
			$(document).ready(function () {
				document.querySelector('#sidebar_toggle').dispatchEvent(new Event('click'))
			})
		} else if (window.innerWidth > Theme.screens.xl.replace('px', '') && document.querySelector('#sidebar').classList.contains('collapsed') === true) {
			$(document).ready(function () {
				document.querySelector('#sidebar_toggle').dispatchEvent(new Event('click'))
			})
		}
	} catch (e) {

	}
})

// at page load
if (window.innerWidth < Theme.screens.xl.replace('px', '')) {
	$('#sidebar').css('width', '0px').addClass('collapsed')
	$('#sidebar_toggle').find('span').html('left_panel_open')
}

// tablayout
extendWindow({
	createTablayout: (wrapper) => {
		TabLayout.init(wrapper);
	}
})

// breadcrumb
extendWindow({
	createBreadcrumb: (wrapper) => {
		BreadCrumb.init(wrapper);
	}
})

// modal
const MODAL_INSTANCE = new Modal();

extendWindow({
	createModal: (wrapper, options) => {
		MODAL_INSTANCE.createModal(wrapper, options);
	},
	createOneOffModal: (link, options) => {
		MODAL_INSTANCE.oneOff(link, options);
	},
	openModal: (wrapper) => {
		wrapper.openModal();
	},
	closeModal: (wrapper) => {
		wrapper.closeModal();
	},
	onModalLoad: (wrapper, callback) => {
		wrapper.onModalLoad = callback;
	},
	onModalClose: (wrapper, callback) => {
		wrapper.onModalClose = callback;
	},

})

window.$.fn.extend({
	createModal: function (options) {
		return this.each(function () {
			MODAL_INSTANCE.createModal(this, options);
		});
	},
	openModal: function () {
		return this.each(function () {
			this.openModal();
		});
	},
	closeModal: function () {
		return this.each(function () {
			this.closeModal();
		});
	},
	onModalLoad: function (callback) {
		return this.each(function () {
			this.onModalLoad = callback;
		});
	},
	onModalClose: function (callback) {
		return this.each(function () {
			this.onModalClose = callback;
		});
	}
});

// element drawer
extendWindow({
	ElementBox: ElementBox
})

// delegate
extendWindow({
	on: delegate
})

// buttonFunctions
const bf = new ButtonFunctions();
extendWindow({
	loaderButtonInit: bf.loaderButtonInit,
})

// theme changer
extendWindow({
	changeTheme: ThemeChanger.changeTheme
})

// div functions
extendWindow({
	load: async (element, callback) => {
		element.classList.add('div-loading')
		// generate random id
		const id = 'spinner-' + Math.random().toString(36).substr(2, 9)
		// add a spinner
		const spinnerTemplate = `<div class="div-spinner" id="${id}">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>`

		let spinnerElement = document.createElement('div')
		spinnerElement.innerHTML = spinnerTemplate

		// remove the parent div
		spinnerElement = spinnerElement.firstChild

		element.appendChild(spinnerElement)

		await callback()

		element.querySelector(`#${id}`)?.remove()
		element.classList.remove('div-loading')
	}
})


// window.addEventListener('load', function () {
// code to be executed after all JavaScript has been loaded
// $('#page-loader').addClass('hidden')
// $('#main').removeClass('hidden')
// });


import initComponentFunctionsAndAnimations from './components/component-functionality';
import tippy from 'tippy.js';

window.tippy = tippy;

initComponentFunctionsAndAnimations()
initElements()